import { useAppSelector } from "@/store";
import { categoriesSelector } from "@/store/categories/categoriesSlice";
import { HeaderDropdownItem } from "@/components/layout/header/HeaderDropdown";
import { isWritingServiceSelector } from "@/store/global/globalSlice";

import * as toolPreviews from "@/content/tool-previews";

const categoriesIcons: Record<string, string> = {
  "arts-and-humanities-essay": "categories-art",
  "business-essay-examples": "categories-business",
  "information-technology-essays": "categories-information-technology",
  "law-essay": "categories-law",
  other: "categories-other",
  "science-essay-samples": "categories-sciences",
  "social-sciences-samples": "categories-social-sciences",
};

type MenuSubItem = {
  href?: string;
  text: string;
  icon?: string;
  items?: MenuSubItem[];
};

type MenuItem = {
  name: string;
  href?: string;
  includeSubdomain?: boolean;
  items?: MenuSubItem[];
};

export const useHeaderMenu = (): MenuItem[] => {
  const categories = useAppSelector(categoriesSelector);

  const isWritingService = useAppSelector(isWritingServiceSelector);

  return isWritingService
    ? ([
        {
          name: "About us",
          href: "/about-us",
          includeSubdomain: true,
        },
        {
          name: "Contact us",
          href: "/contacts",
          includeSubdomain: true,
        },
        {
          name: "FAQ",
          href: "/faq",
          includeSubdomain: true,
        },
        // {
        //   name: "Samples",
        //   href: "/search",
        // },
      ] as MenuItem[])
    : [
        {
          name: "Essay types",
          href: "/essay-types",
        },
        {
          name: "Categories",
          items: categories.map((category) => {
            const obj: HeaderDropdownItem = {
              href: `/${category.slug}`,
              text: category.name,
              icon: categoriesIcons[String(category.slug)],
            };

            if (category.subcategories.length) {
              obj.items = category.subcategories.map(({ slug, name }) => ({
                href: `/${category.slug}/${slug}`,
                text: name,
              }));
            }

            return obj;
          }),
        },
        {
          name: "Tools",
          items: [
            {
              href: "/tools",
              text: "All tools",
              icon: "all",
            },
            ...Object.values(toolPreviews).map(({ slug, heading }) => ({
              href: `/${slug}`,
              text: heading,
              icon: slug,
            })),
          ],
        },
      ];
};
